var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RegisterSuccess"},[_c('HeaderNav',{attrs:{"title":"提交成功"}}),_vm._m(0),_c('FooterNav',{staticClass:"footerNav"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reg-step3-content"},[_c('div',{staticClass:"submit-wrap"},[_c('img',{attrs:{"src":require("./images/提交成功.png"),"height":"150","width":"150"}}),_c('h1',[_vm._v("提交成功")]),_c('span',[_vm._v("审核大概需要1个工作日。")])])])
}]

export { render, staticRenderFns }